import coreImage from './assets/generated/hospium-core.png';
import idImage from './assets/generated/hospium-id.png';
import selfCareImage from './assets/generated/hospium-self-care.png';
import pharmaImage from './assets/generated/hospium-pharma.png';

export const hospiumProducts = [
  {
    key: 'core',
    name: 'Hospium Core',
    label: 'Hospital Management System',
    short: 'A complete HIMS for connected clinical, administrative, billing, pharmacy, workforce, and reporting workflows.',
    description: 'Hospium Core gives hospitals one reliable operational system—from registration and consultations to billing, pharmacy, inpatient care, reporting, and management oversight.',
    image: coreImage,
    points: ['Connected patient records', 'Clinical and administrative workflows', 'Billing, pharmacy, workforce, and reports'],
  },
  {
    key: 'id',
    name: 'Hospium ID',
    label: 'NFC Patient Identification',
    short: 'NFC-powered patient cards and wristbands that make trusted identification fast and practical.',
    description: 'Hospium ID links an NFC-enabled card or wristband to a patient identity, helping participating facilities retrieve the right basic patient context and connect patients to Hospium services.',
    image: idImage,
    points: ['NFC cards and wristbands', 'Fast patient identification', 'Designed for Core and Self Care'],
  },
  {
    key: 'self_care',
    name: 'Hospium Self Care',
    label: 'Universal Patient Portal',
    short: 'A patient portal for hospitals using Hospium Core to offer appointments, telehealth, and linked care services.',
    description: 'Patients sign in using their Hospium ID to reach services offered by their connected hospital, including appointments, telehealth, and access to linked care information.',
    image: selfCareImage,
    points: ['Hospium ID sign-in', 'Appointments and telehealth', 'Hospital-linked patient services'],
  },
  {
    key: 'pharma',
    name: 'Hospium Pharma',
    label: 'Pharmacy Management System',
    short: 'A standalone pharmacy platform for stock, dispensing, sales, invoices, payments, and operational reporting.',
    description: 'Hospium Pharma helps independent pharmacies control medicine stock, store and shelf movements, dispensing, customers, sales, invoices, payments, receipts, refills, and reports.',
    image: pharmaImage,
    points: ['Stock and shelf control', 'Sales, invoices, and payments', 'Dispensing, refills, and reports'],
  },
];

export const contactDetails = {
  whatsappDisplay: '+255 749 487 578',
  whatsappUrl: 'https://wa.me/255749487578',
  email: 'hospium@werenium.com',
};
